<template>
  <div class="d-flex align-center all-width" data-testid="page-header">
    <div class="d-flex align-center">
      <v-btn v-if="showBack" icon @click="$emit('back')" class="mr-2" data-testid="page-header__back-btn">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h3 class="font-weight-medium" data-testid="page-header__title">{{ title }}</h3>
       <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon :class="{ 'rotate': loading }" @click="$emit('refresh')"
          data-testid="page-header__refresh-btn">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span data-testid="page-header__refresh-tooltip">Refresh</span>
    </v-tooltip>
    </div>
   
     
 
  <v-spacer></v-spacer>
  <base-button v-if="isFlowEnabled" primary label="Flow" @click="$emit('flow-dispatch')" data-testid="queue-management__dispatch-btn" />
  </div>
  
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isFlowEnabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
